<template>
  <div id="app">
    <div>
      <popupSection ref="popupSection"/>
    </div>
    <NavbarSection @open-popup="openPopup"/>
    <router-view></router-view>
    <Footer/> 
    
  </div>
 


</template>

<script>
import NavbarSection from './components/Navbar.vue';
import Footer from './components/Footer.vue';
import popupSection from './components/popup.vue';
export default {
  name: 'App',
  components: {
    NavbarSection,
    Footer,
    popupSection,
},
  data() {
    return {
      currentSection: 'about'
    };
  },
  methods: {
    showSection(section) {
      this.currentSection = section;
    },
    openPopup() {
      this.$refs.popupSection.openPopup();
    }
  }
  
}

</script>

<style>
/* Add your global styles here */
.nav {
  display: flex;
  justify-content: center;
  background-color: #444;
  padding: 10px;
}

button:not(.social-button):not(.closebutton):not(.carousel-button), .btnn{
  position: relative;
  border-radius: 10px;
  background: linear-gradient(90deg, #12DBE5 0%, #1F5799 48.96%, #F20000 100%);
  transition: all 0.3s ease-in-out;
  padding: 12px 24px;
  color: #fff;
  border: none;
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0 3px 0 #000;
  overflow: hidden;
  cursor: pointer;
}

button:hover, .btnn:hover {
  box-shadow: 0 6px 15px rgba(255, 0, 0, 0.5);
}

button:hover a {
    color: #fff; 
}

button:active:not(.closebutton):not(.social-button):not(.carousel-button), .btnn:active{
  transform: perspective(200px) translateZ(-100px);
  box-shadow: 0 3px 0px #000;
  background: linear-gradient(90deg, #F20000 0%, #1F5799 48.96%, #12DBE5 100%);
  color: white;
}

.btnn {
  display: inline-flex;
  align-items: center;
  justify-content: center; 
  border-radius: 16px;
  text-decoration: none;
  text-align: center;
  min-width: 150px; 
  height: 50px; 
  white-space: nowrap; 
}

.carousel-button:active {
  transform: perspective(200px) translateZ(-100px);
  box-shadow: 0 3px 0px #000;
}

.social-button:active {
  transform: perspective(200px) translateZ(-100px);
  box-shadow: 0 3px 0px #000;
}

.social-button {
  width: 55px;  
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 10px; 
}

.social-button img {
  width: 100%; 
  height: auto;
}

button:active a {
    color: white;
}

.closebutton {
  cursor: pointer;
  color: #fff;
  padding: 5px;
  border-radius: 10px;
  font-size: 20px;
  border: 0px;
  left: 142px;
  top: 5px;
  position: relative;
  background-color: #1f1f1f;
  background: none;
  box-shadow: none; 
  display: inline-block; 
}

</style>